import React, { useState, useEffect, useLayoutEffect } from "react";
import "../Header/styles.css"
import api from "../Services/api";
import "../../assets/css/dist/historia.dist.css";
import backImage from "../../assets/img/img-vitrine.jpg";

const Banner = () => {

    const [banners, setBanner] = useState<any[]>([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        api
            .get("/ObterBanners")
            .then((response) => {
                setBanner(response.data.results);
                ////console.log("Banner :", response.data.results)
            })
            .catch((err) => {
                throw new Error(err);
            });
    }, []);

    useLayoutEffect(() => {
        function updateWindowWidth() {
            setWindowWidth(window.innerWidth);
        }

        window.addEventListener("resize", updateWindowWidth);

        return () => {
            window.removeEventListener("resize", updateWindowWidth);
        };
    }, []);


    return (

        <div id="myCarousel" className="carousel slide" data-ride="carousel">

            {/* <div className='custom-slide-container'>
                <div className='container'>
                    <ol className="carousel-indicators custom-carousel-indicators">
                        {banners[0] && <li data-target="#myCarousel" data-slide-to="0" className="active carousel"></li>}
                        {banners[1] && <li data-target="#myCarousel" data-slide-to="1" className="carousel"></li>}
                        {banners[2] && <li data-target="#myCarousel" data-slide-to="2" className="carousel"></li>}
                    </ol>
                </div>
            </div> */}

            <div className="carousel-inner">

                {banners?.map((banner, index) => (
                    <div key={index} data-bs-interval="2000" className={`item ${index === 0 ? "active" : ""}`}>
                        <section className="vitrine" style={{ marginTop: window.innerWidth <= 590 ? "64px" : "0", }}>

                            {banner?.Link &&
                                <a rel="noreferrer" href={banner?.Link} target="_blank">
                                    <div className="swiper-container carousel-vitrine">
                                        <div className="swiper-wrapper">
                                            <div className="swiper-slide vitrine_slide position-relative">
                                                <img
                                                    alt="Vitrine"
                                                    className="img-vitrine vitrine-size"
                                                    src={banner?.URL}
                                                    onError={({ currentTarget }) => {
                                                        currentTarget.onerror = null;
                                                        currentTarget.src = backImage;
                                                    }}
                                                    style={{
                                                        objectFit: "contain",
                                                        width: "100%",
                                                        height: "auto",
                                                    }}
                                                />
                                                <div className="overlay"></div>
                                                <div className="vitrine__slide-content">
                                                    <div className='container'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <h2 className="text-white">{banner?.Title}</h2>
                                                                {banner?.Descricao && <div className="text">
                                                                </div>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </a>
                            }
                            {!banner?.Link &&
                                <div className="swiper-container carousel-vitrine">
                                    <div className="swiper-wrapper">
                                        <div className="swiper-slide vitrine_slide position-relative">

                                            <img alt="Vitrine" style={{ objectFit: "fill" }} className="img-vitrine vitrine-size" src={banner?.URL} onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = backImage;
                                            }} />
                                            <div className="overlay"></div>
                                            <div className="vitrine__slide-content">
                                                <div className='container'>
                                                    <div className='row'>
                                                        <div className='col-lg-6'>
                                                            <h2 className="text-white">{banner?.Title} </h2>
                                                            {banner?.Descricao && <div className="text">
                                                            </div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            }
                        </section>
                    </div>
                ))}

            </div>

            <div className='custom-slide-container'>
                <div className='container'>
                    <ol className="carousel-indicators custom-carousel-indicators">
                        {banners[0] && <li data-target="#myCarousel" data-slide-to="0" className="active carousel"></li>}
                        {banners[1] && <li data-target="#myCarousel" data-slide-to="1" className="carousel"></li>}
                        {banners[2] && <li data-target="#myCarousel" data-slide-to="2" className="carousel"></li>}
                    </ol>
                </div>
            </div>

        </div>
    )
};
export default Banner;